const LoadSource = {
  UNKNOWN: "UNKNOWN",
  SYLECTUS: "SYLECTUS",
  MANUAL_INTERNAL: "MANUAL_INTERNAL",
  LOADHIVE: "LOADHIVE",
  LOADHIVE_BUSINESS: "LOADHIVE_BUSINESS",
  IVIA: "IVIA",
  MVF: "MVF",
  FULL_CIRCLE_TMS: "FULL_CIRCLE_TMS",
  ASCENT: "ASCENT",
  FEDEX: "FEDEX",
  EXPRESS_FAMILY: "EXPRESS_FAMILY",
  VETSLG: "VETSLG",
  TRISTATE: "TRISTATE",
  LOAD_ONE: "LOAD_ONE",
} as const;

type LoadSource = (typeof LoadSource)[keyof typeof LoadSource];

export default LoadSource;
export type { LoadSource };
